export default __webpack_public_path__ + "static/media/fancywoodfloor.2e853935.png";